import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
let BrandingService = class BrandingService {
    branding;
    constructor() { }
    setThemeColors(branding) {
        this.branding = branding;
    }
    static ctorParameters = () => [];
};
BrandingService = __decorate([
    Injectable({
        providedIn: "root"
    })
], BrandingService);
export { BrandingService };
